(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["local-hats-exit-survey"] && !Shopify.designMode) return;
  try {
    (() => {
const d=document.getElementById('lh-exit');
if(!d||typeof d.showModal!=='function')return;
const key='lh_exit_survey_v1',start=Date.now();
let shown=false,focus,high=scrollY;
const read=()=>{try{return sessionStorage.getItem(key)}catch{return null}};
const mark=()=>{try{sessionStorage.setItem(key,'shown')}catch{}};
const show=()=>{if(shown||read()||document.visibilityState!=='visible'||document.querySelector('dialog[open]')||Date.now()-start<20000)return;shown=true;mark();focus=document.activeElement;d.showModal()};
d.querySelector('[data-close]').onclick=()=>d.close();
d.querySelector('[data-skip]').onclick=()=>d.close();
d.addEventListener('close',()=>{if(focus?.isConnected)focus.focus()});
d.addEventListener('click',e=>{const r=d.getBoundingClientRect();if(e.target===d&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))d.close()});
d.querySelector('form')?.addEventListener('submit',()=>{const reason=d.querySelector('input[type=radio]:checked')?.value;if(reason)d.querySelector('[name="contact[body]"]').value='Reason for not purchasing: '+reason});
if(location.hash==='#LocalHatsExitFeedback'&&d.querySelector('[data-success],.errors')){shown=true;mark();d.showModal();return}
if(!/^\/(products|collections|cart)(\/|$)/.test(location.pathname)&&location.pathname!=='/')return;
document.addEventListener('mouseout',e=>{if(matchMedia('(pointer:fine)').matches&&!e.relatedTarget&&e.clientY<=0)show()});
addEventListener('scroll',()=>{high=Math.max(high,scrollY);if(matchMedia('(pointer:coarse)').matches&&Date.now()-start>=45000&&high>innerHeight&&high-scrollY>180)show()},{passive:true});
document.addEventListener('submit',e=>{if(e.submitter?.name==='checkout')mark()},true);
document.addEventListener('click',e=>{const a=e.target.closest('a[href]');if(a&&/\/checkout(?:[/?#]|$)/.test(a.getAttribute('href')))mark()},true);
})();
  } catch(e) { console.error(e); }
})();

})();
